import { styled } from '@linaria/react';
import { motion } from 'framer-motion';
export const PanesAmount = /*#__PURE__*/styled('div')({
  name: "PanesAmount",
  class: "p1kou0ul",
  propsAsIs: false
});
export const IndicatorWrapper = /*#__PURE__*/styled('div')({
  name: "IndicatorWrapper",
  class: "im7j2jl",
  propsAsIs: false
});
const _exp10 = /*#__PURE__*/() => motion.div;
export const DotIndicator = /*#__PURE__*/styled(_exp10())({
  name: "DotIndicator",
  class: "dox60fk",
  propsAsIs: true
});
const _exp15 = /*#__PURE__*/() => motion.div;
export const PaneStyled = /*#__PURE__*/styled(_exp15())({
  name: "PaneStyled",
  class: "p1cj2d9t",
  propsAsIs: true
});
const _exp17 = /*#__PURE__*/() => motion.div;
export const Pinchable = /*#__PURE__*/styled(_exp17())({
  name: "Pinchable",
  class: "p1atbmf1",
  propsAsIs: true
});
export const FullSizeWrapper = /*#__PURE__*/styled('div')({
  name: "FullSizeWrapper",
  class: "flvlfrw",
  propsAsIs: false
});
const _exp18 = /*#__PURE__*/() => motion.div;
const _exp19 = /*#__PURE__*/() => ({
  width
}) => width;
export const Container = /*#__PURE__*/styled(_exp18())({
  name: "Container",
  class: "c2ey5ti",
  propsAsIs: true,
  vars: {
    "c2ey5ti-0": [_exp19(), "px"]
  }
});

require("./styled.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styled.tsx");